import { AppBar, Box, Grid, Toolbar, Typography } from "@material-ui/core";
import { useAppSelector } from "../../app/hooks";
import { useTranslation } from 'react-i18next';

export const MyAppBar = () => {
  const { t } = useTranslation();
  const isTest = useAppSelector(state => {
    return state.inputAnswer.session.cxHttpRes?.isTest;
  });

  const isPreviewMode = useAppSelector(state => state.preview.isReviewMode);

  let title = '';
  switch(true) {
    case isPreviewMode:
      title = t('appBar.title.preview_mode');
      break;
    case isTest:
      title = t('appBar.title.test_mode_on');
      break;
    default:
      break;
  }

  return (
    <>
      <AppBar color="primary">
        <Toolbar>
          <Grid
            item
            xs={12}
          >
            <Typography variant="h5" align="center">
              <Box fontWeight="fontWeightBold">{title}</Box>
            </Typography>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
}
